import React from "react";
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
} from "@mui/material";

import AutoCompleteMultiple from "./AutoCompleteMultiple";
import { VariableOption } from "../../types";

type FilterSectionProps = {
  id: string;
  choice: VariableOption;
  variableKey: string;
  onVariableChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  variableChoices: VariableOption[];
  options: string[];
  helperText: string;
  controlId: string;
  lockLabel: string;
  lockHelperText: string;
  lockChecked: boolean;
  lockDisabled: boolean;
  onLockChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string[];
  setValue: (newValue: string[] | undefined) => void;
  maxToSelect: number;
  loading: boolean;
  error: string | null;
  loadingCopy: string;
  formatOptionLabel?: (option: string) => React.ReactNode;
  formatTagLabel?: (option: string) => React.ReactNode;
  isOptionGroup?: (option: string) => boolean;
  showVariableSelect?: boolean;
};

const FilterSection = ({
  id,
  choice,
  variableKey,
  onVariableChange,
  variableChoices,
  options,
  helperText,
  controlId,
  lockLabel,
  lockHelperText,
  lockChecked,
  lockDisabled,
  onLockChange,
  value,
  setValue,
  maxToSelect,
  loading,
  error,
  loadingCopy,
  formatOptionLabel,
  formatTagLabel,
  isOptionGroup,
  showVariableSelect = true,
}: FilterSectionProps) => (
  <div className="controlsGroup" key={id}>
    <div className="controlsGroupHeader">
      {showVariableSelect ? (
        <TextField
          select
          variant="outlined"
          size="small"
          label="Variabel"
          value={variableKey}
          onChange={onVariableChange}
          className="sectionSelect"
        >
          {variableChoices.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      ) : (
        <h2>{choice.label}</h2>
      )}
      <p className="helperText">
        {helperText}
        <br />
        {lockHelperText}
      </p>
    </div>
    <FormControlLabel
      className="lockToggle"
      control={
        <Checkbox
          color="primary"
          checked={lockChecked}
          onChange={onLockChange}
          disabled={lockDisabled}
        />
      }
      label={lockLabel}
    />
    <AutoCompleteMultiple
      id={controlId}
      label={choice.label}
      options={options}
      disabled={loading || !!error}
      value={value}
      setValue={setValue}
      maxToSelect={maxToSelect}
      formatOptionLabel={formatOptionLabel}
      formatTagLabel={formatTagLabel}
      isOptionGroup={isOptionGroup}
    />
    {loading && <p className="helperText">{loadingCopy}</p>}
    {error && <p className="helperText helperText--error">{error}</p>}
  </div>
);

export default FilterSection;
